import { useCallback, useEffect, useRef, useState } from 'react';

export const BIZY_GIGGLE_DURATION_MS = 1260;

export const useBizyBodyGiggle = (): {
	isGiggling: boolean;
	triggerGiggle: () => void;
} => {
	const [isGiggling, setIsGiggling] = useState(false);
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	const clearGiggleTimeout = useCallback(() => {
		if (timeoutRef.current) clearTimeout(timeoutRef.current);
		timeoutRef.current = null;
	}, []);

	const triggerGiggle = useCallback(() => {
		clearGiggleTimeout();
		setIsGiggling(true);
		timeoutRef.current = setTimeout(() => {
			timeoutRef.current = null;
			setIsGiggling(false);
		}, BIZY_GIGGLE_DURATION_MS);
	}, [clearGiggleTimeout]);

	useEffect(() => clearGiggleTimeout, [clearGiggleTimeout]);

	return { isGiggling, triggerGiggle };
};
